<template>
  <div>
    <section id="skills" v-if="data.skills">
      <div class="section" v-if="data.skills">
        <transition appear @before-enter="beforeEnterH1" @enter="enterH1">
          <h1>{{ "" }}</h1>
        </transition>
        <transition-group
          appear
          tag="div"
          class="grid grid-3"
          @before-enter="beforeEnter"
          @enter="enter"
        >
          <Progress
            v-for="(skill, index) in data.skills"
            :key="skill.skill"
            :skill="skill"
            :data-index="index"
          />
        </transition-group>
      </div>
      <Langs
        v-if="data.languages"
        :langs="data.languages"
        :beforeEnter="beforeEnter"
        :enter="enter"
      />
    </section>
    <Error
      v-if="error"
      :error="error"
      :beforeEnter="beforeEnter"
      :enter="enter"
    />
  </div>
</template>
<script>
import Progress from "./skills/Progress";
import Langs from "./skills/Langs";
import gsapAnimation from "../composables/gsapAnimation";
import getData from "../composables/getData";
import { Error } from "../components";
export default {
  components: { Progress, Langs, Error },
  setup() {
    const { beforeEnterH1, enterH1, beforeEnter, enter } = gsapAnimation({
      h1: "Skills",
      y: 150,
      ease: "back",
    });
    const { data, error, fetchData } = getData(process.env.VUE_APP_PROFILE);
    fetchData();
    return {
      beforeEnterH1,
      enterH1,
      beforeEnter,
      enter,
      data,
      error,
      fetchData,
    };
  },
};
</script>
<style scoped>
#skills .grid {
  white-space: break-spaces;
  text-align: center;
}
</style>
